import { Component, OnInit } from '@angular/core'

@Component({
    templateUrl: './external-layout.component.html',
    selector: 'external-layout',
    styleUrls: ['./external-layout.component.scss']

})

export class ExternalLayoutComponent implements OnInit {

    ngOnInit(): void {
    }

}
